import {ReactSVG} from "react-svg";
import ActivityContext, {IActivity} from "../contexts/Activity.tsx";
import React, {FormEvent, useContext, useEffect, useRef, useState} from "react";
import {useDraggable, DragOverlay} from '@dnd-kit/core';
import {isMobile} from "../helpers/isMobile.ts";


interface IActivityItemProps{
    Activity : IActivity,
}
export const ActivityItem = ({Activity} : IActivityItemProps) =>{
    const  [title, setTitle] = useState<string>('');
    const  [titleText, setTitleText] = useState<string>('');
    const  [editMode, setEditMod] = useState<boolean>(false);
    const  {resolvedActivity,setCurrentActivityResolved,resolveActivity}  = useContext(ActivityContext);
    const {attributes, listeners, setNodeRef, transform} = useDraggable({
        id: 'draggable',
        disabled : !!resolvedActivity
    });
    const style = transform ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
    } : undefined;
    const myRef = useRef(null);
    const inputRef = useRef(null);
    useEffect(() => {
        if (myRef.current) {
            // @ts-ignore
            window.dragoffset ={
                // @ts-ignore
                x : myRef.current.getBoundingClientRect().left  | 0,
                // @ts-ignore
                y : myRef.current.getBoundingClientRect().top  | 0
            }
        }
    }, [myRef.current,Activity]);
    useEffect(() => {
        setTitle('');
        setTitleText('');
        setEditMod(false);
        if(Activity.editable){
            setCurrentActivityResolved(true);
        }
    }, [Activity]);

    useEffect(() => {
        if(editMode){
            inputRef.current && inputRef.current.focus();
        }
    }, [editMode]);

    return <div className={"activity-item"+ (!!resolvedActivity ? ' inactive' : '')}>
        { Activity.editable && !title ? <>
            {editMode ?
                <div className={'add-custom-activity'} aria-label={"Create your own activity"}>
                    <ReactSVG className={'inactive'} src={Activity.image} />
                    <div className={"add-custom-activity-title"}>
                        <input ref={inputRef} type={"text"} placeholder={"הקלד את שם הפעילות"} value={titleText}
                               onClick={(e ) =>{
                                   // @ts-ignore
                                   e.target.focus()
                               }}
                               onInput={(e:React.ChangeEvent<HTMLInputElement >) => {
                                   setTitleText(e.target.value);
                                   if(!e.target.value){
                                       setEditMod(false);
                                       setCurrentActivityResolved(true)
                                   }
                               }}
                               onKeyUp={(e) => {
                                   console.log(e.keyCode)
                                   if(e.keyCode === 13){
                                       setTitle(titleText);
                                       Activity.title = titleText;
                                   }
                                   if(e.keyCode === 27){
                                       setEditMod(false);
                                       setCurrentActivityResolved(true)
                                   }
                               }}
                               onBlur={(e) =>{
                                   if(!e.target.value){
                                       setEditMod(false);
                                       setCurrentActivityResolved(true)
                                   }
                               }}
                               maxLength={40} />
                        <button type={"submit"} value={"Set activity title"} disabled={!titleText} onClick={() => {
                            setTitle(titleText);
                            Activity.title = titleText;
                        }} >Set activity title</button>
                    </div>
                </div>
                : <button className={'add-custom-activity'} aria-label={"Create your own activity"} onClick={()=>{
                    setEditMod(true);
                    setCurrentActivityResolved(false)
                }}>
                    <span>+</span>
                    <strong>הוספת פעילות משלך</strong>
                </button>
            }
        </> : <>
            <div className={"image-holder"} ref={myRef}>
                <button ref={setNodeRef} {...listeners} {...attributes} aria-label={"משכו את " + Activity.title + " " + "לשטח האווטר ומקמו על פי רמת האהבה"} style={{
                    touchAction : 'none'
                }}>
                    <ReactSVG src={Activity.image} />
                </button>
                {!resolvedActivity && <DragOverlay className={'drag-el'} style={{
                    pointerEvents : 'none'
                }} dropAnimation={null}>
                    <ReactSVG src={Activity.image} style={{
                        scale: isMobile() ? 1 :'20%',
                        pointerEvents : 'none'
                    }}  />
                </DragOverlay>}
            </div>
            <h2>{Activity.title}</h2>
        </>}
    </div>
}